module.exports = __webpack_public_path__ + "img/resumeclinic.7ff67497.svg";